import React, { useContext } from 'react';
import { TagContext } from '../tag-context';

import Modal from '../../../app/modal/v3';
import TagManagement from './index';

const CollectionTagManagement = ({ chapters, isFromBookCreation, revalidate, journalId, onClose }) => {
  const { setCurrent } = useContext(TagContext);

  return (
    <Modal
      close={{
        onClose,
      }}
      title={isFromBookCreation ? "Edit Chapters" : "Add a Chapter"}
      shadeProps={{ pt: [0, 4] }}
      borderRadius={[0, '8px']}
    >
      <TagManagement onClose={onClose} revalidate={revalidate} onClickTag={tag => setCurrent(tag)} journalId={journalId} chapters={(chapters || []).map(({ attributes }) => attributes)} />
    </Modal>
  );
};


export default CollectionTagManagement;
